/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetMaintenanceExpenseResponse
 */
export interface AssetMaintenanceExpenseResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetMaintenanceExpenseResponse
     */
    personCount: number;
    /**
     * 
     * @type {number}
     * @memberof AssetMaintenanceExpenseResponse
     */
    amount: number;
}

/**
 * Check if a given object implements the AssetMaintenanceExpenseResponse interface.
 */
export function instanceOfAssetMaintenanceExpenseResponse(value: object): value is AssetMaintenanceExpenseResponse {
    if (!('personCount' in value) || value['personCount'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function AssetMaintenanceExpenseResponseFromJSON(json: any): AssetMaintenanceExpenseResponse {
    return AssetMaintenanceExpenseResponseFromJSONTyped(json, false);
}

export function AssetMaintenanceExpenseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetMaintenanceExpenseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'personCount': json['personCount'],
        'amount': json['amount'],
    };
}

export function AssetMaintenanceExpenseResponseToJSON(json: any): AssetMaintenanceExpenseResponse {
    return AssetMaintenanceExpenseResponseToJSONTyped(json, false);
}

export function AssetMaintenanceExpenseResponseToJSONTyped(value?: AssetMaintenanceExpenseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personCount': value['personCount'],
        'amount': value['amount'],
    };
}

